import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { colors } from '@/styles'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 16px 0;
`

const SubWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;

  & > *:first-child {
    margin-right: 5px;
  }
`

const Paragraph = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: ${colors.grey48};
  text-align: left;
  margin: 0;
`

const ModalContent = props => {
  const { t } = useTranslation()
  return (
    <Wrapper>
      <Paragraph>
        {t('l.contract_edit.modal_content.title', 'You are responsible for ensuring that:')}
      </Paragraph>
      <SubWrapper>
        <Paragraph>{t('l.contract_edit.modal_content.1.title', '1.')}</Paragraph>
        <Paragraph>
          {t('l.contract_edit.modal_content.1.text', 'This document is correctly filled out;')}
        </Paragraph>
      </SubWrapper>
      <SubWrapper>
        <Paragraph>{t('l.contract_edit.modal_content.2.title', '2.')}</Paragraph>
        <Paragraph>
          {t(
            'l.contract_edit.modal_content.2.text',
            'This document is legally compliant with the laws of the province or territory in which the rental property is located; and'
          )}
        </Paragraph>
      </SubWrapper>
      <SubWrapper>
        <Paragraph>{t('l.contract_edit.modal_content.3.title', '3.')}</Paragraph>
        <Paragraph>
          {t(
            'l.contract_edit.modal_content.3.text',
            'You have positioned the signature fields and dates for each signing party in the appropriate places.'
          )}
        </Paragraph>
      </SubWrapper>
    </Wrapper>
  )
}

export default ModalContent
